module.exports = __webpack_public_path__ + "static/media/country_so.09e39c23.webp";